exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */:host{display:block}button{text-transform:uppercase}::ng-deep .email gh-auth-number-request{margin:0 40px 0 10px}", ""]);

// exports
